import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';

export function useViewTemplateWithUITemplate(
  workflowTemplateId?: string | null,
  viewTemplateId?: string | null,
): {
  viewTemplate?: MBAPI.GetViewTemplateQueryWithUITemplate_getViewTemplate;
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    MBAPI.GetViewTemplateQueryWithUITemplate,
    MBAPI.GetViewTemplateQueryWithUITemplateVariables
  >(Queries.viewTemplate.getViewTemplateWithUITemplate, {
    variables: {
      input: { workflowTemplateId: workflowTemplateId ?? '', id: viewTemplateId ?? '' },
    },
    skip: isNil(workflowTemplateId) || isNil(viewTemplateId),
  });

  return {
    viewTemplate: data?.getViewTemplate,
    loading,
    error,
  };
}
